import { EditorComponentProps, EditorMode } from "@/Apps/Pages/Editor/types";
import { IAction } from "@/Apps/Pages/Properties/BuildingBlocks/Interactions/types";

export enum OrderBumpTypes {
  INLINE,
  BLOCK,
}

export interface OrderBumpProps {
  id?: string;
  mode?: EditorMode;
  children?: React.ReactNode | string;
  style?: React.CSSProperties;
  properties?: React.CSSProperties;
  actions: IAction[];
  type?: OrderBumpTypes;
  html?: React.ReactNode | string;
  updateComponentSettings: any;
  getComponentSettings: any;
}

export interface PluginProps extends EditorComponentProps {
  settings: OrderBumpProps;
  match?: any;
}
